/**
 * Session tokens: refresh in sessionStorage (tab-scoped); access in memory for axios (not localStorage).
 */

const REFRESH_KEY = 'refreshToken';

let accessToken = null;

export function getAccessToken() {
    return accessToken;
}

export function setAccessToken(token) {
    accessToken = token || null;
}

export function clearAccessToken() {
    accessToken = null;
}

export function getRefreshToken() {
    if (typeof sessionStorage === 'undefined') return null;
    return sessionStorage.getItem(REFRESH_KEY);
}

export function setRefreshToken(token) {
    if (typeof sessionStorage === 'undefined') return;
    if (token) {
        sessionStorage.setItem(REFRESH_KEY, token);
    } else {
        sessionStorage.removeItem(REFRESH_KEY);
    }
}

export function clearRefreshToken() {
    if (typeof sessionStorage === 'undefined') return;
    sessionStorage.removeItem(REFRESH_KEY);
}

/** Set when the weekly-report banner is dismissed; cleared on logout so it returns next login. */
export const WEEKLY_REPORT_BANNER_DISMISSED_KEY = 'weeklyReportBannerDismissed';

export function clearAuthSession() {
    clearAccessToken();
    clearRefreshToken();
    try {
        sessionStorage.removeItem(WEEKLY_REPORT_BANNER_DISMISSED_KEY);
    } catch {
        /* storage unavailable */
    }
}
